/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import HelpCenterSettingsWidgetConfigurationInstallAppQuery, {
	type HelpCenterSettingsWidgetConfigurationInstallAppQuery as HelpCenterSettingsWidgetConfigurationInstallAppQueryType,
} from './__generated__/HelpCenterSettingsWidgetConfigurationInstallAppQuery.graphql';

type InstallEntryPointComponent = EntryPointComponent<
	{
		page: HelpCenterSettingsWidgetConfigurationInstallAppQueryType;
	},
	{},
	{},
	{} | null
>;

export const installEntryPoint: EntryPoint<InstallEntryPointComponent, EntryPointRouteParams> =
	createEntryPoint({
		root: JSResourceForUserVisible<InstallEntryPointComponent>(
			/* webpackChunkName: "async-help-center-setting-widget-configuration-install-app" */ './HelpCenterSettingsWidgetConfigurationInstallApp.tsx',
			{
				entryFsSsrLiftImportToModule: true,
			},
		),
		getPreloadProps: ({
			context: {
				match: {
					params: { helpCenterId, widgetId },
				},
			},
			tenantContext: { cloudId, activationId },
		}: EntryPointRouteParams) => {
			return {
				queries: {
					page: {
						parameters: HelpCenterSettingsWidgetConfigurationInstallAppQuery,
						variables: {
							cloudId,
							helpCenterAri: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`,
							widgetId: widgetId ?? '',
						},
						options: {
							fetchPolicy: 'store-or-network' as const,
						},
					},
				},
			};
		},
	});
